import type { Example } from '../types';

export const stepperGridStackExample: Example = {
  id: 'stepper-grid-stack',
  title: 'Stepper, Grid & Stack Inputs',
  categoryId: 'parameters',
  description: 'Prev/next stepper, 2D grid picker, drag-reorderable stack',
  scadCode: `/* Stepper, Grid & Stack Inputs */

// markdown:tip
// **Stepper** — Use \`<val:Label, ...>\` syntax for prev/next arrow buttons.
// **Grid Input** — A 2D array with \`// grid: CxR [opts]\` becomes a
// clickable cell grid. **Stack** — A 1D array with \`// stack: [opts]\`
// renders as a drag-reorderable list of items.

/* [Stepper] */

// Quality preset — click ◀ ▶ to step through options
quality = 32; // <16:Draft, 32:Standard, 64:Fine, 128:Ultra>

/* [Grid Layout] */

// Cell grid — click cells to toggle on/off (1=on, 0=off)
// A 3×3 grid of boolean cells
cell_grid = [[1,0,1],[0,1,0],[1,0,1]]; // grid: 3x3 [0, 1]

/* [Layer Stack] */

// Layer order — drag to reorder, click + / × to add/remove
layers = ["base", "middle", "top"]; // stack: 0:3 [base, middle, top, cap, ring]

/* [Appearance] */

// Color
// color
body_color = [0.4, 0.4, 0.75];

// --- parameters end ---

cell_size = 14;
gap = 2;
layer_h = 8;
layer_colors = [
  [0.4, 0.4, 0.75],
  [0.6, 0.4, 0.65],
  [0.75, 0.5, 0.4],
  [0.4, 0.7, 0.5],
  [0.7, 0.7, 0.3],
];

// Grid — render each active cell as a rounded peg
for (r = [0:2], c = [0:2]) {
  active = cell_grid[r][c];
  if (active == 1) {
    x = (c - 1) * (cell_size + gap);
    y = (r - 1) * (cell_size + gap);
    color(body_color)
    translate([x, y, 0])
      cylinder(d=cell_size * 0.85, h=6, center=false, $fn=quality);
  }
}

// Stack — render each layer as a colored disc offset upward
for (i = [0:len(layers)-1]) {
  name = layers[i];
  col_idx = (name == "base")   ? 0 :
            (name == "middle") ? 1 :
            (name == "top")    ? 2 :
            (name == "cap")    ? 3 : 4;
  color(layer_colors[col_idx])
  translate([50, 0, i * (layer_h + 2)])
    cylinder(d=30 - i * 3, h=layer_h, center=false, $fn=quality);
}
`,
};
